import { postAPI } from 'framework/api/http';
import { useMutation } from 'react-query';

interface VerifyOTPInterface {
  data: string;
  serverRef: string;
}

export const useVerifyOTP = () => {
  const mutate = useMutation(({ data, serverRef }: VerifyOTPInterface) => {
    return postAPI('/creator-api/verify_otp', {
      data,
      serverRef,
    });
  });

  return mutate;
};

export default useVerifyOTP;
